import React, { useEffect } from "react";
import "../GrievancePolicy/GrievancePolicy.css";
import Footer from "../../Components/Footer.jsx";
import Help from "../../Components/Help/Help.jsx";

const RefundPolicy = () => {
  return (
    <div style={{ background: "white" }}>
      <section className="Grievance-Policy">
        <h1 className="cooky">Refund Policy</h1>
      </section>
      <section className="section_2"></section>
      <div className="Cookie_policy_data">
        <p>
          <strong>1. Merchant Cancellation Policy</strong>
        </p>
        <p>
          Cancellations are not permitted once a transaction is initiated
          through our website or mobile application. All transactions are
          considered final and cannot be reversed.
        </p>
        <p>
          <strong>2. Merchant Failed Transactions</strong>
        </p>
        <p>
          In case of a failed transaction due to payment gateway errors,
          operator issues, or technical failures, if funds are deducted from
          your account, the refund will be processed within 7 working days.
        </p>
        <p>
          <strong>3. Finality of Sales</strong>
        </p>
        <p>
          All payments for recharges, bill payments, and other related services
          are non-refundable and non-exchangeable. It is the sole responsibility
          of the merchant to accurately enter and verify all biller details,
          such as mobile number, DTH number, or utility account number, before
          confirming a transaction. NTAR Bizz will not be held responsible for
          any losses, failed transactions, or service issues arising from
          incorrect or incomplete details provided by the merchant.
        </p>
        <p>
          <strong>4. Service Not Delivered to Biller</strong>
        </p>
        <p>
          If a payment has been successfully deducted but the recharge or
          service is not delivered within 24 hours, merchants must contact NTAR
          Bizz customer support. The following details must be provided:
          <ul style={{ paddingLeft: "1rem" }}>
            <li>Registered mobile number / DTH / Account number</li>
            <li>Operator name</li>
            <li>Service or recharge amount</li>
            <li>Transaction date</li>
            <li>Order number</li>
          </ul>
        </p>
        <p>
          <strong>5. Refund Processing</strong>
        </p>
        <p>
          Once verified, if it is confirmed that payment was deducted but the
          service was not delivered, NTAR Bizz will initiate a refund within 7
          working days. Refunds for payments made through credit card, debit
          card, or net banking will be credited back to the respective bank or
          card account.
        </p>

        <p>
          <strong>6. Merchant Return Policy</strong>
        </p>
        <p>
          NTAR Bizz does not offer any return option. Once a transaction has
          been processed successfully, no returns can be claimed.
        </p>
      </div>

      {/* Help Center Section */}

      <Help
        buttonLabel="Chat Support"
        href="https://wa.me/9188545454"
        isExternalLink={true}
      />
      <br></br>
      <br />
      <Footer />
    </div>
  );
};

export default RefundPolicy;
